import React, { useState, useCallback, useMemo } from 'react';
import { Resizable } from 'react-resizable';
import 'react-resizable/css/styles.css';

const ResizableTitle = (props: any) => {
  const { onResize, width, ...restProps } = props;

  if (!width) {
    return <th {...restProps} />;
  }

  return (
    <Resizable
      width={width}
      height={0}
      handle={
        <span
          className="react-resizable-handle"
          onClick={(e) => e.stopPropagation()}
          style={{
            position: 'absolute',
            right: -5,
            bottom: 0,
            top: 0,
            width: 10,
            cursor: 'col-resize',
            zIndex: 1,
          }}
        />
      }
      onResize={onResize}
      draggableOpts={{ enableUserSelectHack: false }}
    >
      <th {...restProps} />
    </Resizable>
  );
};

const useResizableColumns = (initialColumns: any[]) => {
  const [columnWidths, setColumnWidths] = useState<Record<string, number>>(() => {
    const widths: Record<string, number> = {};
    initialColumns.forEach((col) => {
      if (col.width && col.key) {
        widths[col.key] = col.width;
      }
    });
    return widths;
  });

  const handleResize = useCallback(
    (key: string) =>
      (_: any, { size }: { size: { width: number } }) => {
        setColumnWidths((prev) => ({
          ...prev,
          [key]: size.width,
        }));
      },
    []
  );

  const resizableColumns = useMemo(() => {
    return initialColumns.map((col) => {
      const width = columnWidths[col.key] || col.width;
      if (!width) return col;
      return {
        ...col,
        width,
        onHeaderCell: (column: any) => ({
          width: column.width,
          onResize: handleResize(col.key),
        }),
      };
    });
  }, [initialColumns, columnWidths, handleResize]);

  const components = useMemo(
    () => ({
      header: {
        cell: ResizableTitle,
      },
    }),
    []
  );

  return { columns: resizableColumns, components };
};

export default useResizableColumns;
